import { render, staticRenderFns } from "./TabEstadisticas.vue?vue&type=template&id=3b098589&scoped=true&"
import script from "./TabEstadisticas.vue?vue&type=script&lang=js&"
export * from "./TabEstadisticas.vue?vue&type=script&lang=js&"
import style0 from "./TabEstadisticas.vue?vue&type=style&index=0&id=3b098589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b098589",
  null
  
)

export default component.exports